
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { QRCodeModule } from 'angularx-qrcode';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { FieldTypeContactsComponent } from "../field-type-contacts/field-type-contacts.component";
import { FieldTypeSwitchComponent } from "../field-type-switch/field-type-switch.component";
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { FieldTypeRichTextEditableComponent } from "../field-type-rich-text/field-type-rich-text-editable/field-type-rich-text-editable.component";
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';

@Component({
  selector: 'share-link-modal',
  templateUrl: './share-link-modal.component.html',
  standalone: true,
  imports: [
    AfTranslateDirective,
    QRCodeModule,
    FieldTypeContactsComponent,
    FieldTypeSwitchComponent,
    AfTranslatePipe,
    FieldTypeRichTextEditableComponent
  ]
})
export class ShareLinkModalComponent implements OnInit {
  constructor(private dialogRef: DynamicDialogRef<ShareLinkModalComponent>,
    private dialogConfig: DynamicDialogConfig,
    private translate: AfTranslateFactory,
    private commonUtilsService: CommonUtilsService,
    private modalService: ModalServiceService,
    private apiService: ApiServiceService) { }

  shareLinkModal: any = {
    comment: '',
    contactsField: {
      typeConfiguration: 'publish-concept',
      multiple: true,
      addContacts: true,
      required: true,
      typeCall: 'contacts',
      selectContacts: []
    },
    commentField: { label: this.translate.instant('common.comment') }
  }

  ngOnInit(): void {
    this.getNotifyModel();
  }

  getNotifyModel() {
    this.apiService.add('notifications/preview/publicconceptshared/concept/' + this.dialogConfig.data.conceptId)
      .then((data: any)=> {
        this.shareLinkModal.htmlModelNotify = data;
      }, (errorData:any)=>{});
  }

  receiveContacts(e:any){
    this.shareLinkModal.contactsField.selectContacts = e.contacts;
    if(this.shareLinkModal.contactsField.selectContacts?.length){
      this.shareLinkModal.contactsField.error = false;
    }
  }

  shareLink(){
    if(this.shareLinkModal.contactsField.selectContacts?.length){
      this.setMessageForDestinations();
    }else{
      this.shareLinkModal.contactsField.error = true;
      this.modalService.errorModal({ text: this.translate.instant('public-link.error-configuration-share-link') });
    }
  }

  setMessageForDestinations(){
    if(this.shareLinkModal.comment){
      this.shareLinkModal.comment = this.commonUtilsService.extractInnerHTML(this.shareLinkModal.comment);
      this.shareLinkModal.contactsField.selectContacts.forEach((contact: any) => {
        contact.comments = this.shareLinkModal.comment;
      });
    }
    this.handleAccept();
  }

  openPreviewNotify(){
    this.modalService.notificationPreview({html: this.shareLinkModal.htmlModelNotify});
  }

  handleAccept() {
    this.dialogRef.close({
      result: 'ok',
      checkCopyNotification: this.shareLinkModal.checkCopyNotification,
      selectContacts: this.shareLinkModal.contactsField.selectContacts
    });
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }
}
